import { motion } from "framer-motion";
import { Wine, Heart, Sparkles, Sun, Users } from "lucide-react";

const items = [
  {
    icon: Wine,
    title: "Champagne & Light Bites",
    description: "Sip, savor, and settle into the evening with curated refreshments.",
  },
  {
    icon: Users,
    title: "Connection with Like-Minded Women",
    description: "Meet women who share your desire for growth, rest, and authenticity.",
  },
  {
    icon: Sparkles,
    title: "A Beautiful Atmosphere",
    description: "Experience the luxurious ambiance of SKYN CULTURE in Atlanta.",
  },
  {
    icon: Sun,
    title: "Costa Rica Retreat Preview",
    description: "Get an intimate look at the Sister Diamonds Just Be retreat experience.",
  },
  {
    icon: Heart,
    title: "Inspiration for Your Next Season",
    description: "Find inspiration for your own season of rest, reset, and rising.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

export default function WhatToExpect() {
  return (
    <section
      data-testid="what-to-expect-section"
      className="py-24 md:py-32 bg-secondary/30"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-primary mb-4 block font-['Outfit']">
            The Experience
          </span>
          <h2 className="text-3xl md:text-5xl font-light tracking-tight">
            Come Enjoy
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {/* Large image card - spans 1 col on md, 1 row on lg */}
          <motion.div
            className="lg:row-span-2 min-h-[300px]"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeUp}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <div className="h-full overflow-hidden border border-white/5 relative group">
              <img
                src="https://i.ontraport.com/260712.e8246cf334e8430fccff91d4d75d391c.PNG"
                alt="Luxury retreat accommodation"
                className="w-full h-full object-cover absolute inset-0 group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-sm font-['Outfit'] tracking-wide text-foreground/80">
                  An evening you won't forget
                </p>
              </div>
            </div>
          </motion.div>

          {/* Text cards */}
          {items.map((item, i) => (
            <motion.div
              key={item.title}
              className="bg-card/50 border border-white/5 p-7 md:p-8 flex flex-col gap-4"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={fadeUp}
              transition={{ duration: 0.6, delay: 0.15 + i * 0.08 }}
            >
              <item.icon
                strokeWidth={1}
                size={28}
                className="text-primary"
              />
              <div>
                <h3 className="text-xl md:text-2xl font-light tracking-tight mb-2">
                  {item.title}
                </h3>
                <p className="text-sm font-['Outfit'] font-light text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
